import { EntityBadge } from '@abb-procure/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { SearchInsightsService } from '../../services/search-insights.service';
import { SearchState } from '../../store/search.state';
import { SearchBaseDto } from '../../types/search-base-dto.type';
import { SearchHierarchyElementDto } from '../../types/search-hierarchy-element-dto.type';
import { SearchResultItemDto } from '../../types/search-result-item-dto.type';

@Component({
  selector: 'procure-search-entity-badge',
  templateUrl: './search-entity-badge.component.html',
  styleUrl: './search-entity-badge.component.scss',
  imports: [EntityBadge],
  host: {
    '[hidden]': '!this.label()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchEntityBadge {
  readonly index = input<number | null>(null);
  readonly label = input.required<string | null>();

  readonly item = input.required<
    SearchResultItemDto | SearchBaseDto | SearchHierarchyElementDto
  >();

  protected readonly link = computed(() => {
    const item = this.item();

    if (this.isHierarchy(item)) {
      switch (item.entity_type) {
        case 'SUP':
          return `/supplier/${item.entity_number}`;
        case 'LDI':
          return `/organisation/local-divisions/${item.entity_number}`;
        case 'HUB':
          return `/organisation/hubs/${item.entity_number}`;
        case 'DIV':
          return `/organisation/divisions/${item.entity_number}`;
        default:
          return `/${item.entity_number}`;
      }
    }

    switch (item.entityType) {
      case 'SUP':
        return `/supplier/${item.id}`;
      case 'LDI':
        return `/organisation/local-divisions/${item.id}`;
      case 'HUB':
        return `/organisation/hubs/${item.id}`;
      case 'DIV':
        return `/organisation/divisions/${item.id}`;
      default:
        return `/${item.entityNumber}`;
    }
  });

  private readonly state = inject(SearchState);
  private readonly insightsService = inject(SearchInsightsService);

  protected openEntity(): void {
    const item = this.item();
    const index = this.index();

    this.state.hideSearch();

    if (index === null) {
      return;
    }

    if (this.isHierarchy(item)) {
      return;
    }

    this.insightsService.logEvent({
      name: 'Click Search Routing',
      rank: index,
      item,
    });
  }

  private isHierarchy(
    item: SearchResultItemDto | SearchBaseDto | SearchHierarchyElementDto,
  ): item is SearchHierarchyElementDto {
    return (item as SearchHierarchyElementDto).entity_type !== undefined;
  }
}
